import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

export default function VerifyPhone() {
  const [code, setCode] = useState('');
  const [loading, setLoading] = useState(false);
  const { verifyPhone } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await verifyPhone(code);
      toast.success('Phone verified successfully!');
      navigate('/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 px-4">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-2xl shadow-xl">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-slate-900" style={{fontFamily: 'Space Grotesk, sans-serif'}}>Verify Your Phone</h1>
          <p className="mt-2 text-slate-600" style={{fontFamily: 'Inter, sans-serif'}}>Enter the 6-digit code sent to your phone</p>
        </div>
        
        <form onSubmit={handleSubmit} className="mt-8 space-y-6">
          <div>
            <Label htmlFor="code">Verification Code</Label>
            <Input
              id="code"
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              data-testid="verification-code-input"
              className="mt-1 text-center text-2xl tracking-widest"
              maxLength={6}
              pattern="[0-9]{6}"
            />
          </div>

          <Button
            type="submit"
            disabled={loading || code.length !== 6}
            data-testid="verify-button"
            className="w-full"
          >
            {loading ? 'Verifying...' : 'Verify Phone'}
          </Button>
        </form>
        
        <div className="text-center pt-6 border-t border-slate-200">
          <a
            href="https://donate.stripe.com/5kQ6oH99f72ze6OcIK4ZG00"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-slate-400 hover:text-slate-600"
          >
            Support this project
          </a>
        </div>
      </div>
    </div>
  );
}
